module.exports = __webpack_public_path__ + "static/feature_soft-987b451ab0f1a266513800935c6029dd.png";